import React from 'react'
import PropTypes from 'prop-types'

// Styled Elements
import { Wrapper, BarBackdrop, BarLine } from './MoneyBar.elements'

function MoneyBar(props) {
  // Destructure
  const { width, ...rest } = props

  return (
    <Wrapper {...rest}>
      <BarBackdrop />
      <BarLine style={{ width }} />
    </Wrapper>
  )
}

// Default Props
MoneyBar.defaultProps = {
  width: '',
}

// Proptypes Validation
MoneyBar.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default MoneyBar
